import EnvConfig from './envConfig';
import content from '../constants/content';
/**
 * api endpoint configuration imported and passed to httpService from each components
 */
const CommonAPiConfig = {
  Cards: {
    selectProperties:
      'Title,EYKDDescription,EYKDTileImagePath,EYKDLicenseStatus,Path,EYKDCollateralID,ListItemID,EYKDProviderUrl,EYKDTileImagePath,EYKDBannerImagePath,owstaxIdEYKDSector,owstaxIdEYKDServiceLine,owstaxIdEYKDGeoScope,owstaxIdEYKDGeoAccess,EYKDAssetType,owstaxIdEYKDLanguage,EYKDLicenseStatus,EYKDProviderType,EYKDContactsOWSUSER,EYKDLastUpdatedDate,EYKDViewCount,EYKDTitle,EYKDRegistration,EYKDAccessUrl,EYKDAccessInformation,EYKDSolutions,EYKDLearningMaterials,EYKDSupport,EYKDOnlineResources,EYKDBestPractisesUseCases,EYKDCopyright,EYKDRestrictions,EYKDExternalRedistribution,EYKDInternalRedistribution,EYKDTopics,owstaxIdEYKDCategory,EYKDAssociatedDataAssetsID,EYKDAssociatedDataProviderID,EYKDAssociatedDataProvider,EYKDAccessButtonLabel,EYKDAccessRequest,EYContentType,Created,EYKDDataDelivery,CreatedBy,AuthorOWSUSER',
  },
  refinersList: {
    refiners:
      'owstaxIdEYKDSector(filter=1000/0/*),owstaxIdEYKDServiceLine(filter=1000/0/*),owstaxIdEYKDGeoAccess(filter=1000/0/*),owstaxIdEYKDGeoScope(filter=1000/0/*),EYKDLicenseStatus(sort=name/ascending),EYKDTopics(sort=name/ascending),EYKDDataDelivery(sort=name/ascending),owstaxIdEYKDCategory(filter=1000/0/*)',
  },
};

const CommonClientAPiConfig = {
  Common: {
    'include-attributes': true,
    'page-number': 1,
    'sort-by': 'name',
    'sort-mode': 'asc',
    'page-size': content.ApiRowLimit.searchResult,
    'attributes-to-include': [
      'Name',
      'DTPRD_Type',
      'EXP_LicenseStatus',
      'AccessURL',
      'EXP_GN_Description',
      'ID',
      'MDW_CatalogObjectID',
    ],
  },
};

const ApiConfig = {
  baseUrl: {
    local: 'https://acemwpddscapiweb01.azurewebsites.net',
    development: 'https://api-dev.discover.ey.com',
    qa: 'https://api-qa.discover.ey.com',
    uat: 'https://api-uat.discover.ey.com',
    prod: 'https://api.discover.ey.com',
  },
  appBaseUrl: {
    local: 'http://localhost:3000',
    development: 'https://data-dev.discover.ey.com',
    qa: 'https://data-qa.discover.ey.com',
    uat: 'https://data-uat.discover.ey.com',
    prod: 'https://data.discover.ey.com',
  },
  header: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  endpointConfig: {
    peopleProfile: {
      params: '?accountname=i:0%23.f%7cmembership%7c{email}',
    },
    detailData: {
      method: 'GET',
      endpoint: '/details',
    },
    homePageData: {
      method: 'GET',
      endpoint: '/homePageData',
    },
    collateralAndPeople: {
      method: 'POST',
      endpoint: '/v1/data/dataassetdetails',
      data: {
        relatedAssetsQuery: {
          ...EnvConfig.RelatedAssets,
          ...CommonAPiConfig.Cards,
        },
      },
    },
    getGlossaryData: {
      method: 'GET',
      endpoint: '/v1/data/glossary',
    },
    getWhatsNewData: {
      method: 'GET',
      endpoint: '/v1/data/whatsnew',
    },
    getNewJoinerData: {
      method: 'GET',
      endpoint: '/v1/data/newjoiner',
    },
    getDataProductData: {
      method: 'GET',
      endpoint: '/v1/data/dataproduct',
    },
    getProfilePhoto: {
      method: 'GET',
      baseUrl: 'https://graph.microsoft.com',
      endpoint: '/v1.0/me/photo/$value',
      tokenId: 'readToken',
      header: {
        'Content-Type': 'image/jpg',
      },
    },
    getRecentViewJson: {
      method: 'GET',
      endpoint: '/v1/data/getRecentlyViewed',
    },
    getMyDataSection: {
      method: 'GET',
      endpoint: '/v1/data/getMyDataSection',
    },
    getRequestAccess: {
      method: 'GET',
      endpoint: '/v1/data/getRequestAccess',
    },
    getDPFRequestAccess: {
      method: 'GET',
      endpoint: '/v1/data/fetchDPFData',
    },
      getDataProductId: {
      endpoint: 'https://data.ey.com/jabberwock/metadata/meta/global/#requestId#/?filter=eq(managed_attribute,mngdK71023277508746f4b183054264273384)',
    },
    getDPFTeamRequestAccess: {
      endpoint: 'https://data.ey.com/jabberwock/metadata/team/',
    },
    getDPFClrmRequestAccess: {
      endpoint: 'https://data.ey.com/jabberwock/metadata/clrm/',
    },
    getDPFMetadataRequestAccess: {
      endpoint: 'https://data.ey.com/jabberwock/metadata/clrm/clrmID/',
    },
    getDPFDprdRequestAccess: {
      endpoint: 'https://data.ey.com/jabberwock/metadata/dprd/',
    },
    updateRecentlyViewed: {
      method: 'POST',
      endpoint: '/v1/data/updateRecentlyViewed',
    },
    addMyDataTile: {
      method: 'POST',
      endpoint: '/v1/data/addMyDataTile',
    },
    dataProductRequestCreate: {
      method: 'POST',
      endpoint: '/v1/data/createDataProductRequest',
      isMDWRequest: true,
      data: {
        answers: {},
      },
    },
    removeMyDataTile: {
      method: 'POST',
      endpoint: '/v1/data/removeMyDataTile',
    },
    recentlyViewQuery: {
      method: 'POST',
      endpoint: '/v1/data/search/postquery',
      data: {
        ...CommonAPiConfig.Cards,
        ...EnvConfig.RecentlyView,
        querytext: '*',
        rowLimit: content.ApiRowLimit.recentlyView,
        enableSorting: true,
      },
    },
    popularQuery: {
      method: 'POST',
      endpoint: '/v1/data/search/postquery',
      data: {
        ...CommonAPiConfig.Cards,
        ...CommonAPiConfig.refinersList,
        ...EnvConfig.Popular,
        querytext: '*',
        rowLimit: content.ApiRowLimit.popular,
        enableSorting: true,
      },
    },
    topicQuery: {
      method: 'POST',
      endpoint: '/v1/data/search/postquery',
      data: {
        ...EnvConfig.Topic,
        querytext: '*',
        selectProperties:
          'Title,ListItemID,EYKDDescription,EYKDTileImagePath,EYKDLicenseStatus,Path,EYKDSortOrder',
        enableSorting: true,
      },
    },
    searchResultData: {
      method: 'POST',
      endpoint: '/v1/data/search/postquery',
      data: {
        ...CommonAPiConfig.Cards,
        ...CommonAPiConfig.refinersList,
        ...EnvConfig.Results,
        querytext: '*',
        rowLimit: content.ApiRowLimit.searchResult,
      },
    },
    clientDataQuery: {
      method: 'POST',
      endpoint: '/v1/data/search/clientpostquery',
      data: {
        ...CommonClientAPiConfig.Common,
        ...content.clientAPIDefault,
      },
      isMDWRequest: true,
    },
    clientDataSearch: {
      method: 'POST',
      endpoint: '/v1/data/search/clientpostquery',
      data: {
        ...CommonClientAPiConfig.Common,
        ...content.searchByAttributes,
      },
      isMDWRequest: true,
    },
    clientDataSearchById: {
      method: 'POST',
      endpoint: '/v1/data/search/clientpostquery',
      data: {
        ...CommonClientAPiConfig.Common,
        ...content.filterByCatalogObjectIds,
      },
      isMDWRequest: true,
    },
    configurationData: {
      id: 'configAPI',
      method: 'GET',
      endpoint: '/v1/data/configurations',
    },
    getHierarchicalRefinerValues: {
      id: 'termStoreAPI',
      method: 'GET',
      endpoint: '/v1/data/getTerms',
    },
    FetchMdwToken: {
      id: 'FetchMdwToken',
      method: 'GET',
      endpoint: '/v1/data/validateAdGroup/FetchMdwToken',
    },
    getdpfToken: {
      id: 'getdpftoken',
      method: 'GET',
      endpoint: '/v1/data/getdpftoken',
    },
    getTdsToken: {
      id: 'getTdstoken',
      method: 'GET',
      endpoint: '/v1/data/getTdstoken',
    },
    isValidEYP: {
      id: 'eypuser',
      method: 'GET',
      endpoint: '/v1/data/eypuser',
    },
    getClientDataProductDetail: {
      id: 'getClientDataProductDetail',
      method: 'GET',
      endpoint: '/v1/data/getDataProductDetail',
    },
    getContactPhoto: {
      method: 'POST',
      baseUrl: 'https://graph.microsoft.com',
      endpoint: '/v1.0/$batch',
      tokenId: 'readToken',
      header: {
        'Content-Type': 'application/json',
      },
    },
    getGraphContactData: {
      imageAPI: '/users/{email}/photo/$value',
      userDetailsAPI:
        '/users/{email}?$select=jobTitle,displayName,givenName,mail,mobilePhone,officeLocation,surname,userPrincipalName,id',
    },
    getContact: {
      method: 'POST',
      baseUrl: 'https://graph.microsoft.com',
      endpoint: '/v1.0/$batch',
      tokenId: 'readToken',
      header: {
        'Content-Type': 'application/json',
      },
    },
    getAdGroup: {
      method: 'Get',
      baseUrl: 'https://graph.microsoft.com',
      // endpoint: '/v1.0/groups',
      tokenId: 'readToken',
      header: {
        'Content-Type': 'application/json',
      },
    },
    getSpoToken: {
      id: 'getspotoken',
      method: 'GET',
      endpoint: '/v1/data/getspotoken',
    },
    userLogout: {
      id: 'logout',
      method: 'GET',
      endpoint: '/v1/data/logout',
    },
    searchSuggestionsData: {
      id: 'searchSuggestionsData',
      method: 'GET',
      endpoint: `/v1/data/getQuerySuggestions?query=$value&noOfSuggestions=5`,
    },
    getContactData: {
      method: 'GET',
      endpoint: '/v1/data/getContacts',
    },
    getClientContactData: {
      method: 'GET',
      endpoint: '/v1/data/getclientcontactdetails',
    },
    getAttestion: {
      method: 'GET',
      endpoint: '/v1/data/getTdsAttestation/verify/',
      isTDS: true,
    },
    setAttestion: {
      method: 'POST',
      endpoint: '/v1/data/fetchTdsAttestation',
      isTDS: true,
    },
    searchUser: {
      method: 'GET',
      endpoint: '/v1/data/people-picker/',
    },
    producerList: {
      method: 'GET',
      endpoint: '/v1/data/governor/data-producers-list',
      isMDWRequest: true,
    },
    dataProductRequests: {
      method: 'POST',
      endpoint: '/v1/data/governor/data-product-requests',
      data: {
        'page-number': 1,
        'page-size': 50,
        'sort-by': 'lastUpdatedDate',
        'sort-order': 'desc',
        status: ['Rejected', 'Accepted', 'New'],
        'skip-requests-with-dataproducts': false,
      },
      isMDWRequest: true,
    },
    alldataproducts: {
      method: 'POST',
      endpoint: '/v1/data/governor/dataproducts',
      data: {
        'page-size': 100,
        status: ['Pending', 'Published'],
      },
      isMDWRequest: true,
    },
    producerDataProductRequests: {
      method: 'POST',
      endpoint: '/v1/data/producer/assignedDprlist',
      data: {
        'page-number': 1,
        'page-size': 50,
        'sort-by': 'lastUpdatedDate',
        'sort-order': 'desc',
        'skip-requests-with-dataproducts': false,
      },
      isMDWRequest: true,
    },
    producerMydataproducts: {
      method: 'POST',
      endpoint: '/v1/data/producer/mydataproducts',
      data: {
        'page-number': 1,
        'page-size': 50,
        sortBy: 'CreatedAt',
        sortOrder: 'desc',
        status: [1, 2, 3],
      },
      isMDWRequest: true,
    },
    consumerDataProductRequests: {
      method: 'POST',
      endpoint: '/v1/data/product-requests/list/consumer',
      isMDWRequest: true,
      data: {
        'page-number': 1,
        'page-size': 50,
        sortBy: 'UpdatedAt',
        sortOrder: 'desc',
        status: ['New', 'Accepted', 'Rejected'],
      },
    },
    createDataProduct: {
      method: 'POST',
      endpoint: '/v1/data/producer/createDataProduct',
      isMDWRequest: true,
      data: {
        status: 'draft',
        attributes: {},
      },
    },
    updateDataProduct: {
      method: 'POST',
      endpoint: '/v1/data/producer/data-product/{requestId}/update',
      isMDWRequest: true,
      data: {
        status: 'draft',
        attributes: {},
      },
    },
    productRequestDetails: {
      method: 'GET',
      endpoint: '/v1/data/getProductRequestDetails/',
      isMDWRequest: true,
    },
    approveRejectDataProductRequest: {
      method: 'POST',
      endpoint: '/v1/data/governor/data-product-request/{requestId}/approve',
      isMDWRequest: true,
      data: {
        Accepted: false,
        Comments: '',
      },
    },
    reassignProducer: {
      method: 'POST',
      endpoint: '/v1/data/governor/data-product-request/{requestId}/reassign-producer',
      isMDWRequest: true,
      data: {
        dataProducerId: '',
      },
    },
    getDataProductDetail: {
      method: 'GET',
      endpoint: '/v1/data/get/data-product/{requestId}',
      isMDWRequest: true,
    },
    getUserRoles: {
      method: 'GET',
      endpoint: '/v1/data/user-roles/me',
      isMDWRequest: true,
    },
    approveDataProduct: {
      method: 'POST',
      endpoint: '/v1/data/governor/data-product/{requestId}/approve',
      isMDWRequest: true,
      data: {
        approve: false,
        Comments: '',
      },
    },
    dpRevertToDraft: {
      method: 'POST',
      endpoint: '/v1/data/governor/data-product/{requestId}/revert-to-draft',
      isMDWRequest: true,
    },
    getDPPickList: {
      method: 'GET',
      endpoint: '/v1/data/getpicklist',
    },
  },
};

const ApiErrorMsgConfig = {
  default: {
    default: { header: 'Connection Issue', info: 'Something went wrong. Please try again later.' },
  },
};

export default ApiConfig;
export { ApiErrorMsgConfig };
